export default function isTrue(val) {
  return !!val;
}
